import React from 'react';
import AdminUserDetailSection from './AdminUserDetailSection';

interface AdminUserDetailDefaultPromptSectionProps {
  defaultPromptContent: string;
  setDefaultPromptContent: (v: string) => void;
  loadingDefaultPrompt: boolean;
  savingDefaultPrompt: boolean;
  editingDefaultPrompt: boolean;
  setEditingDefaultPrompt: (v: boolean) => void;
  expanded: boolean;
  onToggle: () => void;
  onSave: () => void;
  onReload: () => void;
}

const AdminUserDetailDefaultPromptSection: React.FC<AdminUserDetailDefaultPromptSectionProps> = ({
  defaultPromptContent,
  setDefaultPromptContent,
  loadingDefaultPrompt,
  savingDefaultPrompt,
  editingDefaultPrompt,
  setEditingDefaultPrompt,
  expanded,
  onToggle,
  onSave,
  onReload,
}) => {
  const headerButton =
    !editingDefaultPrompt && expanded ? (
      <button
        onClick={(e) => {
          e.stopPropagation();
          setEditingDefaultPrompt(true);
        }}
        className="px-3 py-1.5 bg-purple-600/20 hover:bg-purple-600/30 border border-purple-500/30 text-purple-300 hover:text-purple-200 rounded-lg text-xs font-medium transition-colors"
      >
        Edit
      </button>
    ) : null;

  return (
    <AdminUserDetailSection
      sectionId="defaultPrompt"
      title="Default Outbound Prompt"
      expanded={expanded}
      onToggle={onToggle}
      headerButton={headerButton}
    >
      {loadingDefaultPrompt ? (
        <div className="flex items-center justify-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-cyan-500"></div>
        </div>
      ) : (
        <>
          {editingDefaultPrompt ? (
            <div className="space-y-3">
              <textarea
                value={defaultPromptContent}
                onChange={(e) => setDefaultPromptContent(e.target.value)}
                placeholder="Role, goals, conversation style, objections, success criteria..."
                rows={12}
                className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-lg text-xs text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent resize-y font-mono"
                disabled={savingDefaultPrompt}
              />
              <div className="flex gap-2">
                <button
                  onClick={onSave}
                  disabled={savingDefaultPrompt}
                  className="px-4 py-1.5 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg text-xs font-medium hover:from-purple-700 hover:to-purple-800 disabled:opacity-60 transition-all"
                >
                  {savingDefaultPrompt ? 'Saving...' : 'Save'}
                </button>
                <button
                  onClick={() => {
                    setEditingDefaultPrompt(false);
                    onReload();
                  }}
                  className="px-4 py-1.5 bg-white/5 text-gray-300 rounded-lg text-xs font-medium hover:bg-white/10 border border-white/20 transition-colors"
                  disabled={savingDefaultPrompt}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div className="bg-white/5 border border-white/10 rounded-lg p-3">
              <pre className="text-xs text-gray-300 whitespace-pre-wrap font-mono">
                {defaultPromptContent || 'No default prompt configured. Click "Edit" to add one.'}
              </pre>
            </div>
          )}
        </>
      )}
    </AdminUserDetailSection>
  );
};

export default AdminUserDetailDefaultPromptSection;
